import React, {useCallback, useEffect, useState} from "react";
import classNames from "classnames/bind";

import Button from "~/components/button";
import {CnInput} from "~/components/cn-input";
import {CustomLabelTable} from "~/components/custom-label-table/custom-label-table";
import {FilterArea} from "~/components/filter-area";
import {PageTitle} from "~/components/page-title";
import {ContactListDataType} from "~/data/board/contact/use-contact.interface";
import {useContactList} from "~/data/board/contact/use-contact-list";
import {useUser} from "~/data/user";
import {ContactBoardModal} from "~/pages/board/contact/modal/contact-board.modal";

import styles from "./contact-board.page.module.scss";

const cx = classNames.bind(styles);

const ContactBoardPage = () => {
    const perPage = 20;
    const [modal, setModal] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [selectedData, setSelectedData] = useState<ContactListDataType | null>(null);
    const [filter, setFilter] = useState<{keyword: string}>({
        keyword: "",
    });

    const {user} = useUser();

    const {data, submit, loading} = useContactList({
        keyword: filter.keyword,
        page: page,
    });

    const handleReset = useCallback(() => {
        setFilter({
            keyword: "",
        });
    }, []);
    const handleInquiry = () => {
        submit();
        setPage(1);
    };

    const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            submit();
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        submit();
    }, [page]);

    return (
        <div>
            {modal && (
                <ContactBoardModal
                    refresh={() => submit()}
                    close={() => {
                        setModal(false);
                        setSelectedData(null);
                    }}
                    data={selectedData}
                />
            )}
            <PageTitle>마트, 슈퍼 업체연락망 게시판</PageTitle>
            <FilterArea>
                <div className={cx("filter-inner")}>
                    <CnInput
                        label={"검색어"}
                        name={"keyword"}
                        placeholder={"검색어 입력"}
                        value={filter.keyword}
                        onChange={(e) => setFilter({keyword: e.target.value})}
                        onKeyUp={handleKeyUp}
                    />
                    <div className={cx("button-container")}>
                        <Button label={"조회"} color={"primary"} onClick={handleInquiry} />
                        <Button label={"검색조건 초기화"} onClick={handleReset} />
                    </div>
                </div>
            </FilterArea>
            <div className={cx("table-container")}>
                <CustomLabelTable
                    label={
                        <>
                            <span>
                                {data?.allRecordCnt ?? 0} 건
                                {` (${page}/${Math.ceil((data?.allRecordCnt ? data.allRecordCnt : 1) / perPage)} 페이지)`}
                            </span>
                            {user?.division === "MEMBER" && (
                                <Button label={"등록하기"} onClick={() => setModal(true)} />
                            )}
                        </>
                    }
                    totalCount={data?.allRecordCnt ?? 1}
                    perPage={perPage}
                    pagination={false}
                    page={page}
                    onPageChange={(e) => setPage(e)}
                    dataSource={data?.list.map((item, index) => ({...item, index})) ?? []}
                    rowKey={"id"}
                    onRow={(record) => ({
                        onClick: () => {
                            setModal(true);
                            setSelectedData(record);
                        },
                    })}
                    columns={[
                        {
                            title: "No",
                            render: (_, __, index) => Number((page - 1) * perPage + index + 1).toLocaleString(),
                            align: "center",
                            width: "5%",
                        },
                        {
                            title: "구분",
                            dataIndex: "category",
                            align: "center",
                        },
                        {
                            title: "관련공정",
                            dataIndex: "relatedProcess",
                            align: "center",
                        },
                        {
                            title: "계약업체",
                            dataIndex: "contractor",
                            align: "center",
                        },
                        {
                            title: "연락처",
                            dataIndex: "contact",
                            align: "center",
                        },
                        {
                            title: "계약기간",
                            dataIndex: "contractPeriod",
                            align: "center",
                        },
                    ]}
                />
            </div>
        </div>
    );
};

export {ContactBoardPage};
